import { useEffect, useState } from 'react';

export const useTimer = () => {
  const [timer, setTimer] = useState<number>();

  useEffect(() => {
    const timerID =
      timer && timer > 0
        ? setTimeout(() => {
            setTimer((v = 0) => Math.max(v - 1, 0));
          }, 1000)
        : undefined;
    return () => {
      timerID && clearTimeout(timerID);
    };
  }, [timer]);

  return [timer, setTimer] as const;
};
